// src/firebase.js
import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
    apiKey: "AIzaSyA9nt33X-GccgQ_hv_5G9ra400Ps9zJIIs",
    authDomain: "cryptogame-3bd7e.firebaseapp.com",
    projectId: "cryptogame-3bd7e",
    storageBucket: "cryptogame-3bd7e.firebasestorage.app",
    messagingSenderId: "1060882996429",
    appId: "1:1060882996429:web:a83d3247e27be46fcf5d84",
    measurementId: "G-T8SZDJ6RVW"
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);

const provider = new GoogleAuthProvider();

export { auth, provider, db };
